import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RoutingService } from "@spartacus/core";


@Component({
  selector: 'app-acc-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './acc-notification.component.html',
  styleUrls: ['./acc-notification.component.scss']
})
export class AccNotificationComponent  {

  constructor(private readonly router: RoutingService) { }

  viewNotification() {
    this.router.goByUrl('/messageHistoryPage');
  }
}
